// 用户管理相关API服务
import { httpClient } from '../http';
import {
  UserResponse,
  CreateUserRequest,
  UpdateUserRequest,
  ChangePasswordRequest,
  RoleInfo,
  PaginationParams,
  PaginationResponse,
  AuditLog,
  AuditLogParams,
} from '@/types/api';

export class UsersAPI {
  // 获取用户列表
  async getUsers(params?: PaginationParams): Promise<PaginationResponse<UserResponse>> {
    const response = await httpClient.get<PaginationResponse<UserResponse>>('/admin/users', params);
    return response.data;
  }

  // 获取用户详情
  async getUserById(id: number): Promise<UserResponse> {
    const response = await httpClient.get<UserResponse>(`/admin/users/${id}`);
    return response.data;
  }

  // 创建用户
  async createUser(userData: CreateUserRequest): Promise<UserResponse> {
    const response = await httpClient.post<UserResponse>('/admin/users', userData);
    return response.data;
  }

  // 更新用户
  async updateUser(id: number, userData: UpdateUserRequest): Promise<UserResponse> {
    const response = await httpClient.put<UserResponse>(`/admin/users/${id}`, userData);
    return response.data;
  }

  // 删除用户
  async deleteUser(id: number): Promise<void> {
    await httpClient.delete(`/admin/users/${id}`);
  }

  // 获取当前登录用户信息
  async getCurrentUser(): Promise<UserResponse> {
    const response = await httpClient.get<UserResponse>('/admin/users/me');
    return response.data;
  }

  // 更新当前登录用户信息
  async updateCurrentUser(userData: UpdateUserRequest): Promise<UserResponse> {
    const response = await httpClient.put<UserResponse>('/admin/users/me', userData);
    return response.data;
  }

  // 修改密码
  async changePassword(passwordData: ChangePasswordRequest): Promise<void> {
    await httpClient.post('/admin/users/change-password', passwordData);
  }

  // 获取角色列表
  async getRoles(): Promise<RoleInfo[]> {
    const response = await httpClient.get<RoleInfo[]>('/admin/roles');
    return response.data;
  }

  // 获取角色权限说明
  async getRolePermissions(): Promise<any> {
    const response = await httpClient.get('/admin/role-permissions');
    return response.data;
  }

  // 获取审计日志
  async getAuditLogs(params?: AuditLogParams): Promise<PaginationResponse<AuditLog>> {
    const response = await httpClient.get<PaginationResponse<AuditLog>>('/admin/audit', params);
    return response.data;
  }
}

// 导出单例实例
export const usersAPI = new UsersAPI();
